// ** React Imports
import { createContext, useEffect, useState } from 'react'

// ** Next Import
import { useNavigate } from 'react-router-dom'


// ** Axios
import axios from 'axios'

// ** Defaults
const defaultProvider = {
  user: null,
  loading: true,
  setUser: () => null,
  setLoading: () => Boolean,
  gstList: () => Promise.resolve(),
}
const DashboardContext = createContext(defaultProvider)

const DashboardProvider = ({ children }) => {
  // ** States
  const [dashboard, setDashboard] = useState(null)
  const [loading, setLoading] = useState(defaultProvider.loading)
  const [error, setError] = useState('')
  const [totalCounts, setTotalCounts] = useState({
    customer_return: 0,
    wrong_rto: 0,
    non_barcode_rto: 0,
    damage: 0,
    missing_qty: 0,
    otp_less: 0,
    payment: 0,
    returns: 0,
    loss: 0,
  })

  // ** Hooks
  const navigate = useNavigate() // React Router hook for navigation

  const trueClaim = async () => {
    let token = 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJkZW1vQHRzb21zLmNvbSIsImlhdCI6MTc0MTU4MzYwMCwiZXhwIjoxNzQxNjE5NjAwfQ.NS9Lhg76wJLcMc8wPc31DnxWs7MOC0ynqtq5Njz8csA'
    if (token) {
      setLoading(true)
      await axios
        .post(`https://api.trueselleroms.com/user/get-dashboard-data`, {}, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(async response => {
          setLoading(false)
          setDashboard(response.data)
        })
        .catch((error) => {
          // if ((error.response && error.response.status === 403) || !token) {
          //   // localStorage.removeItem("userData")
          //   navigate('/login')
          // } else {
          //   setError('Something Went Wrong')
          //   setTimeout(() => {
          //     setError('')
          //   }, 3000);
          // }
          setLoading(false)
        })

    } else {
      setLoading(false)
    }
  }

  const smartClaim = async () => {
    let token = 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJkZW1vQHRzb21zLmNvbSIsImlhdCI6MTc0MTM0ODIwMSwiZXhwIjoxNzQxMzg0MjAxfQ.Ej0NYiNejM1px014SgCYFv5zQIopaDBhmbQ9HQJOkzs'
    if (token) {
      setLoading(true)
      await axios
        .post(`https://api.trueselleroms.com/smart-claim/count?`, {}, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(async response => {
          setLoading(false)
          setDashboard(response.data)
          setTotalCounts((prev) => ({
            otp_less: response.data.otpLessDelivered.count,
            payment: response.data.paymentNotReceived.count,
            returns: response.data.returnNotReceived.count,
            loss: response.data.lost.count,
            // customer_return:response.data.count
            // wrong_rto:response.data.count
            // non_barcode_rto:response.data.count
            // damage:response.data.count
            // missing_qty:response.data.count
          }));
        })
        .catch((error) => {
          if ((error.response && error.response.status === 403) || !token) {
            navigate('/login')
          } else {
            setError('Something Went Wrong')
            setTimeout(() => {
              setError('')
            }, 3000);
          }
          setLoading(false)
        })

    } else {
      setLoading(false)
    }
  }
  // useEffect(() => {
  //   if (localStorage.getItem("email") && localStorage.getItem("userData")) {
  //     initAuth()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])


  const values = {
    dashboard,
    loading,
    setDashboard,
    setLoading,
    dashboardList: trueClaim,
    dashboardError: error
  }

  return <DashboardContext.Provider value={values}>{children}</DashboardContext.Provider>
}

export { DashboardContext, DashboardProvider }
